import React from 'react';
import { useInfoValue, JobTitle, LosAngelesOfficePhone } from '../Contexts/InfoContext';
import { LosAngelesAddress } from '../Common/LosAngelesAddress';
import PhoneFormatter from '../Common/PhoneNumberFormatter';
import { CompanyURL } from '../Common/CompanyURL';

export const TemplateOne = () => {
	const { data } = useInfoValue();

	const logoImage = 'https://cdn.tgscmedia.com/email-signatures/logo-tgsc.png';
	const telOfficeNumber = data.officePhone ? data.officePhone : '310.376.7800';
	const telMobileNumber = data.mobilePhone ? data.mobilePhone : null;

	return (
		<table
			id="signatureMarkup"
			cellPadding="0"
			cellSpacing="0"
			style={{
				verticalSpacing: '-webkit-baseline-middle',
				fontSize: 'medium',
				fontFamily: 'Helvetica, Arial, sans-serif'
			}}
		>
			<tbody>
				<tr>
					<td style={{ verticalAlign: 'top', display: 'block' }}>
						<table
							cellPadding="0"
							cellSpacing="0"
							style={{
								verticalAlign: '-webkit-baseline-middle',
								fontSize: 'medium',
								padding: '0',
								margin: '0'
							}}
						>
							<tbody>
								<tr>
									<td style={{ textAlign: 'center' }}>
										<a
											href="https://thegoldenstatecompany.com/"
											target="_blank"
											rel="noopener noreferrer"
										>
											<img
												width="110"
												src={logoImage}
												alt="The Golden State Company"
												role="presentation"
												style={{ maxWidth: '110px', display: 'block' }}
											/>
										</a>
									</td>
								</tr>
								<tr>
									<td style={{ textAlign: 'center', verticalAlign: 'bottom' }}>
										<table
											cellPadding="0"
											cellSpacing="0"
											style={{
												verticalAlign: '-webkit-baseline-middle',
												fontSize: 'medium',
												display: 'inline-block'
											}}
										>
											<tbody>
												<tr
													style={{ textAlign: 'center', marginTop: '23px', display: 'block' }}
												>
													<td style={{ padding: '0 5px 0 0' }}>
														<a
															href="https://facebook.com/ourgoldenstate/"
															target="_blank"
															rel="noopener noreferrer"
															style={{
																display: 'inline-block',
																padding: '0px',
																verticalAlign: 'top',
																lineHeight: '10px'
															}}
														>
															<img
																height="20"
																src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/facebook%20icon.png"
																alt="facebook"
																style={{ maxWidth: '135px', display: 'block' }}
															/>
														</a>
													</td>

													<td style={{ padding: '0 5px' }}>
														<a
															href="https://instagram.com/ourgoldenstate/"
															target="_blank"
															rel="noopener noreferrer"
															style={{
																display: 'inline-block',
																padding: '0px',
																verticalAlign: 'top',
																lineHeight: '10px'
															}}
														>
															<img
																height="20"
																src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/instagram%20icon.png"
																alt="instagram"
																style={{ maxWidth: '135px', display: 'block' }}
															/>
														</a>
													</td>

													<td style={{ padding: '0 5px' }}>
														<a
															href="https://twitter.com/ourgoldenstate/"
															target="_blank"
															rel="noopener noreferrer"
															style={{
																display: 'inline-block',
																padding: '0px',
																verticalAlign: 'top',
																lineHeight: '10px'
															}}
														>
															<img
																height="20"
																src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/twitter%20icon.png"
																alt="twitter"
																style={{ maxWidth: '135px', display: 'block' }}
															/>
														</a>
													</td>

													<td style={{ padding: '0 0 0 5px' }}>
														<a
															href="https://linkedin.com/company/the-golden-state-company/"
															target="_blank"
															rel="noopener noreferrer"
															style={{
																display: 'inline-block',
																padding: '0px',
																verticalAlign: 'top',
																lineHeight: '10px'
															}}
														>
															<img
																height="20"
																src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/linkedin%20icon.png"
																alt="linkedin"
																style={{ maxWidth: '135px', display: 'block' }}
															/>
														</a>
													</td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
					</td>

					<td align="center" valign="top">
						<table border="0" cellPadding="0" cellSpacing="0">
							<tbody>
								<tr>
									<td valign="top">
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									</td>
								</tr>
							</tbody>
						</table>
					</td>

					<td style={{ padding: '0px', verticalAlign: 'middle' }}>
						<h3
							color="#181818"
							style={{
								color: '#181818',
								margin: '0px',
								textTransform: 'Capitalize',
								fontSize: '16px',
								font: 'bold',
								fontFamily: 'Helvetica, Arial, sans-serif'
							}}
						>
							<span>{data.firstName ? data.firstName : 'Michael'}</span>
							<span>&nbsp;</span>
							<span>{data.lastName ? data.lastName : 'Scott'}</span>
						</h3>
						<JobTitle />
						<hr
							height="1"
							style={{
								height: '1px',
								border: '0  none',
								color: '#eaeaea',
								backgroundColor: '#eaeaea',
								marginTop: '5px',
								marginBottom: '5px'
							}}
						/>
						<table cellPadding="0" cellSpacing="0" style={{ fontSize: 'medium' }}>
							<tbody>
								<tr style={{ verticalAlign: 'middle' }}>
									<td style={{ padding: '12px 0 0', minWidth: '20px' }}>
										<table cellPadding="0" cellSpacing="0" style={{ fontSize: 'medium' }}>
											<tbody>
												<tr>
													<td
														style={{
															fontSize: '11px',
															color: '#808080',
															lineHeight: '15px',
															textDecoration: 'none',
															marginRight: '5px',
															display: 'block'
														}}
													>
														<span>o.&nbsp;</span>
													</td>

													<td
														style={{
															fontSize: '11px',
															color: '#808080',
															lineHeight: '15px',
															textDecoration: 'none',
															minWidth: '70px'
														}}
													>
														<span>
															<a
																style={{
																	textDecoration: 'none',
																	color: '#808080'
																}}
																href={`tel:${telOfficeNumber}`}
															>
																{telOfficeNumber}
															</a>
														</span>
													</td>
												</tr>
											</tbody>
										</table>
									</td>
									<td style={{ padding: '12px 0 0', minWidth: '20px' }}>
										{data.mobilePhone ? (
											<table cellPadding="0" cellSpacing="0" style={{ fontSize: 'medium' }}>
												<tbody>
													<tr>
														<td
															style={{
																fontSize: '11px',
																color: '#808080',
																lineHeight: '15px',
																textDecoration: 'none',
																marginRight: '5px',
																marginLeft: '10px',
																display: 'block'
															}}
														>
															<span>&nbsp;&nbsp;m.&nbsp;</span>
														</td>

														<td
															style={{
																fontSize: '11px',
																color: '#808080',
																lineHeight: '15px',
																textDecoration: 'none',
																minWidth: '70px'
															}}
														>
															<span>
																<a
																	style={{
																		textDecoration: 'none',
																		color: '#808080'
																	}}
																	href={`tel:${telMobileNumber}`}
																>
																	{telMobileNumber}
																</a>
															</span>
														</td>
													</tr>
												</tbody>
											</table>
										) : null}
									</td>
								</tr>
							</tbody>
						</table>

						<table cellPadding="0" cellSpacing="0" style={{ fontSize: 'medium' }}>
							<tbody>
								<CompanyURL url={'thegoldenstatecompany.com'} />
								<LosAngelesAddress />
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
	);
};
